import { Outlet } from "react-router";

export function ReportLayout() {
  return (
    <main id="main" tabIndex={-1} className="mx-auto w-full max-w-[880px] bg-background px-4 py-8 print:max-w-none print:px-0">
      <Outlet />
    </main>
  );
}
